import React, { useContext } from "react";
import styled, { useTheme } from "styled-components";
import LeftSideBar from "~/components/Layout/LeftSideBar";
import RightSideBar from "~/components/Layout/RightSideBar";
import { Chart } from "chart.js";
import CoreContext from "~/lib/context";
import ErrorBoundaryCard from "~/components/ErrorBoundaryCard";
import AiAssistantDropdown from "~/components/AiAssistantDropdown";
import useAbacExt from "~/hooks/abac";
import { AuthoritiesEnum } from "~/types/enums";
import { enterView, exitView } from "~/lib/animations";
import { Transition, TransitionGroup } from "react-transition-group";
import { useLocation } from "react-router-dom";
const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  max-width: 1440px;
  min-width: 1266px;
  margin: 0 auto;
`;
const Content = styled.div`
  flex-grow: 1;
  width: 100%;
  padding-left: 18.5rem;
  padding-right: ${_ref => {
  let {
    sidebar
  } = _ref;
  return sidebar ? "28.6rem" : "0";
}};
`;
const AIAssistant = styled.div`
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 10;
`;
const Layout = _ref2 => {
  let {
    children
  } = _ref2;
  const {
    sidebar
  } = useContext(CoreContext);
  const location = useLocation();
  const {
    userHas
  } = useAbacExt();
  const theme = useTheme();
  Chart.defaults.color = theme.colors.text.secondary;
  Chart.defaults.font.weight = theme.typography.fontWeight.regular;
  Chart.defaults.font.family = theme.typography.fontFamily.primary;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ErrorBoundaryCard, null, /*#__PURE__*/React.createElement(LeftSideBar, null)), /*#__PURE__*/React.createElement(TransitionGroup, {
    component: null
  }, /*#__PURE__*/React.createElement(Transition, {
    key: location.pathname,
    onEnter: (node, appears) => enterView(node, appears),
    onExit: node => exitView(node),
    timeout: {
      enter: 750,
      exit: 400
    },
    appear: true
  }, /*#__PURE__*/React.createElement(Content, {
    sidebar: !!sidebar
  }, /*#__PURE__*/React.createElement(ErrorBoundaryCard, null, children)))), /*#__PURE__*/React.createElement(ErrorBoundaryCard, null, /*#__PURE__*/React.createElement(RightSideBar, null)), userHas(AuthoritiesEnum.AI_ASSISTANT_READ) && /*#__PURE__*/React.createElement(AIAssistant, null, /*#__PURE__*/React.createElement(AiAssistantDropdown, null)));
};
export default Layout;